import React from 'react';
import PropTypes from 'prop-types';
import './Error.scss';

const Error = (props) => {
    if (props.error.hasError) {
        return(
            <div className="col-xs-12 alert alert-danger fade in ee">
                <button 
                    type="button" 
                    className="close" 
                    onClick={props.onCloseButtonClick}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <strong>{props.error.title}</strong> 
                <br/>
                {props.error.message}
            </div>
            );
        }
    return <div className="ee" />;
};

Error.propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string,
        title: PropTypes.string,
        hasError: PropTypes.bool
    }),
    onCloseButtonClick: PropTypes.func
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/Error/NewError.js